import React, { useState, useEffect } from 'react';
import QuotationLogo from '../../../assets/QuotationLogo.png';
import { settingsTermService } from '../../verve-settings/services/settingsTermService';

export const RoomQuotationTemplate = ({ data }) => {
  const quotation = data || {};
  const rooms = quotation.rooms || []; // Array of { roomName, items: [] }

  const [defaultTerm, setDefaultTerm] = useState(quotation.defaultTerm || null);

  useEffect(() => {
    if (!quotation.defaultTerm) {
      const fetchDefaultTerm = async () => {
        try {
          const res = await settingsTermService.getTerms();
          if (res.success && res.data) {
            const defTerm = res.data.find(t => t.status === 'Active' && !t.isRelatedToAppliances);
            if (defTerm) {
              setDefaultTerm(defTerm);
            }
          }
        } catch (error) {
          console.error("Error fetching default term:", error);
        }
      };
      fetchDefaultTerm();
    }
  }, [quotation.defaultTerm]);

  return (
    <div className="w-full max-w-[794px] mx-auto bg-white text-black font-sans text-[10px] print:m-0 print:w-full print:max-w-none">

      {/* HEADER */}
      <div className="flex w-full border border-black border-b-0 h-[140px]">
        <div className={`flex-[2.5] bg-[#bcbcbc] text-black flex flex-col items-center justify-end pb-1 pt-6 relative`}>
          <h1 className="text-[40px] font-normal tracking-wide mb-6">VERVE KITCHENS</h1>
          <p className="font-bold text-[10px] w-full text-center">
            KVR Holdings Plot # 715, Jublie Hills Road no-36, Hyderabad-500033
          </p>
        </div>
        <div className={`flex-1 bg-[#bcbcbc] flex items-center justify-center`}>
          <img src={QuotationLogo} alt="Verve Kitchens" className="h-[90%] object-contain" />
        </div>
      </div>

      {/* QUOTATION STRIP */}
      <div className={`bg-black text-white text-center py-1 font-bold text-[11px] border border-black border-b-0 border-t-0`}>
        {quotation.isInitial ? 'INITIAL QUOTATION' : 'FINAL QUOTATION'}
      </div>

      {/* CLIENT DETAILS TABLE */}
      <table className="w-full border border-black border-collapse table-fixed">
        <tbody>
          <tr className="border-b border-black">
            <td className="w-[30%] border-r border-black px-2 py-1 font-bold align-middle">Customer Name</td>
            <td className="w-[20%] border-r border-black px-2 py-1 align-middle">{quotation.projectName || quotation.clientName || '-'}</td>
            <td className="w-[25%] border-r border-black px-2 py-1 font-bold align-middle">Date</td>
            <td className="w-[25%] px-2 py-1 text-center align-middle">{quotation.date || '-'}</td>
          </tr>
          <tr className="border-b border-black">
            <td className="w-[30%] border-r border-black px-2 py-1 font-bold align-middle">Location</td>
            <td className="w-[20%] border-r border-black px-2 py-1 align-middle">{quotation.site || '-'}</td>
            <td className="w-[25%] border-r border-black px-2 py-1 font-bold align-middle">Quotation No.</td>
            <td className="w-[25%] px-2 py-1 text-center align-middle">{quotation.quotationNo || '-'}</td>
          </tr>
          <tr className="border-b border-black">
            <td className="w-[30%] border-r border-black px-2 py-1 font-bold align-middle">Contact Ref</td>
            <td className="w-[20%] border-r border-black px-2 py-1 align-middle">-</td>
            <td className="w-[25%] border-r border-black px-2 py-1 font-bold align-middle">Reference / Designer</td>
            <td className="w-[25%] px-2 py-1 text-center align-middle">{quotation.designer || '-'}</td>
          </tr>
        </tbody>
      </table>

      <div style={{ height: '8px' }}></div>

      {/* MAIN DATA TABLE */}
      <table className="w-full border border-black border-collapse table-fixed">
        <thead>
          <tr className="border-y border-black bg-[#e6e6e6]">
            <th className="w-[25%] border-r border-black px-2 py-1 text-left font-bold text-[11px]">Particulars</th>
            <th className="w-[15%] border-r border-black px-2 py-1 text-center font-bold text-[11px]">Design</th>
            <th className="w-[15%] border-r border-black px-2 py-1 text-center font-bold text-[11px]">Colour / Type</th>
            <th className="w-[15%] border-r border-black px-2 py-1 text-center font-bold text-[11px]">Warranty</th>
            <th className="w-[20%] border-r border-black px-2 py-1 text-center font-bold text-[11px]">Additional Notes</th>
            <th className="w-[10%] px-2 py-1 text-right font-bold text-[11px]">Amount</th>
          </tr>
        </thead>
        <tbody>
          {rooms.map((roomData, rIdx) => (
            <React.Fragment key={`room-${rIdx}`}>


              {/* ITEMS LOOP */}
              {roomData.items?.length === 0 && (
                <tr className="border-b border-black bg-white">
                  <td colSpan="6" className="px-2 py-1 text-center text-gray-500 italic">No items added to this room</td>
                </tr>
              )}
              {roomData.items?.map((item, idx) => (
                <React.Fragment key={`room-${rIdx}-item-${idx}`}>
                  {item.isHorizontal ? (
                    <tr className="bg-[#b4b4b4] border-b border-black">
                      <td colSpan="6" className="text-center text-white font-bold py-1 text-[11px] uppercase">{item.name}</td>
                    </tr>
                  ) : (
                    <>
                      <tr className="border-b border-black bg-white">
                        <td className="border-r border-black px-2 py-0.5 font-bold text-[11px] whitespace-pre-wrap">{item.name}</td>
                        <td className="border-r border-black px-2 py-0.5 text-gray-700 text-center">{item.design || '-'}</td>
                        <td className="border-r border-black px-2 py-0.5 text-gray-700 text-center">{item.colour || item.color || '-'}</td>
                        <td className="border-r border-black px-2 py-0.5 text-center text-gray-700">{item.warranty || '-'}</td>
                        <td className="border-r border-black px-2 py-0.5 text-gray-700">{item.additionalNotes || '-'}</td>
                        <td className="px-2 py-0.5 text-right font-bold">{item.amount || '0'}</td>
                      </tr>
                      {((item.details && item.details.length > 0) || item.type) && (
                        <tr className="border-b border-black bg-white text-[10px]">
                          <td className="border-r border-black pl-4 pr-2 py-1 text-gray-900 align-top leading-tight">
                            {item.details && item.details.length > 0 && item.details.map((line, i) => (
                              <div key={i}>{line}</div>
                            ))}
                          </td>
                          <td className="border-r border-black px-2 py-1 align-top text-gray-700"></td>
                          <td className="border-r border-black px-2 py-1 align-top text-gray-700">{item.type}</td>
                          <td className="border-r border-black px-2 py-1"></td>
                          <td className="border-r border-black px-2 py-1"></td>
                          <td className="px-2 py-1"></td>
                        </tr>
                      )}
                    </>
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}

          {/* TOTALS */}
          <tr className="bg-white border-b border-black" style={{ pageBreakInside: 'avoid' }}>
            <td colSpan="5" className="border-r border-black px-2 py-1 text-right font-bold uppercase text-[11px] text-gray-700">
              TOTAL
            </td>
            <td className="px-2 py-1 text-right font-bold">{quotation.totals?.total}</td>
          </tr>
          <tr className="bg-white border-b border-black" style={{ pageBreakInside: 'avoid' }}>
            <td colSpan="5" className="border-r border-black px-2 py-1 text-right font-bold uppercase text-[11px] text-gray-700">
              SPECIAL DISCOUNT
            </td>
            <td className="px-2 py-1 text-right font-bold">{quotation.totals?.discount || '0.00'}</td>
          </tr>
          {quotation.totals?.discount && quotation.totals.discount !== '₹0' && quotation.totals.discount !== '₹0.00' && (
            <tr className="bg-white border-b border-black" style={{ pageBreakInside: 'avoid' }}>
              <td colSpan="5" className="border-r border-black px-2 py-1 text-right font-bold uppercase text-[11px] text-gray-700">
                TAXABLE AMOUNT
              </td>
              <td className="px-2 py-1 text-right font-bold">
                {
                  (quotation.totals?.total && quotation.totals?.discount) ?
                    `₹${Number((parseFloat(quotation.totals.total.replace(/[^0-9.-]+/g, "")) - parseFloat(quotation.totals.discount.replace(/[^0-9.-]+/g, ""))).toFixed(2)).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                    : '-'
                }
              </td>
            </tr>
          )}
          {quotation.totals?.gst && quotation.totals.gst !== '₹0' && (
            <tr className="bg-white border-b border-black" style={{ pageBreakInside: 'avoid' }}>
              <td colSpan="5" className="border-r border-black px-2 py-1 text-right font-bold uppercase text-[11px] text-gray-700">
                GST
              </td>
              <td className="px-2 py-1 text-right font-bold">{quotation.totals.gst}</td>
            </tr>
          )}
          <tr className="bg-white border-b border-black" style={{ pageBreakInside: 'avoid' }}>
            <td colSpan="5" className="border-r border-black px-2 py-1 text-right font-bold uppercase text-[11px] text-gray-800">
              GRAND TOTAL
            </td>
            <td className="px-2 py-1 text-right font-bold">{quotation.totals?.grandTotal}</td>
          </tr>
        </tbody>
      </table>

      {/* TAXES EXTRA */}
      <div style={{ padding: '2px 4px', fontWeight: 'bold', fontSize: '10px' }}>
        *TAXES EXTRA
      </div>

      <div style={{ height: '8px' }}></div>

      {/* TERMS INFORMATION */}
      <table className="w-full border-collapse table-fixed" style={{ pageBreakInside: 'avoid' }}>
        <tbody>
          <tr>
            <td className="px-3 py-3 align-top leading-[1.4] text-[11px] text-black">
              {defaultTerm ? (
                <>
                  <div style={{ fontWeight: 'bold', textDecoration: 'underline', marginBottom: '2px', textAlign: 'left' }}>
                    {defaultTerm.title || "TERMS AND CONDITIONS"}
                  </div>
                  <div
                    className="text-[10px] [&>p]:m-0 [&>p]:leading-tight [&_*]:!border-none [&_table]:!border-0 [&_td]:!border-0 [&_th]:!border-0"
                    dangerouslySetInnerHTML={{ __html: defaultTerm.description }}
                  />
                  {defaultTerm.paymentDescription && (
                    <>
                      <div style={{ fontWeight: 'bold', textDecoration: 'underline', marginTop: '6px', marginBottom: '2px', textAlign: 'left' }}>
                        PAYMENT TERMS
                      </div>
                      <div
                        className="text-[10px] [&>p]:m-0 [&>p]:leading-tight [&_*]:!border-none [&_table]:!border-0 [&_td]:!border-0 [&_th]:!border-0"
                        dangerouslySetInnerHTML={{ __html: defaultTerm.paymentDescription }}
                      />
                    </>
                  )}
                </>
              ) : (
                <div className="text-gray-500 italic text-center">Loading term information...</div>
              )}
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  );
};

export default RoomQuotationTemplate;
